module.exports = __webpack_public_path__ + "img/user1.a44951b5.png";